<template>
  <div class="page-content partner-call-sms-email-mail">
    <partner-call-sms-email-mail-options />
  </div>
</template>

<script lang="ts">
import { nextTick, onMounted } from 'vue';
import { useRoute } from 'vue-router';

import util from '@/Utils/util';

import PartnerCallSmsEmailMailOptions from './CallSmsEmailMailOptions/PartnerCallSmsEmailMailOptions.vue';

export default {
  name: 'PartnerCallSmsEmailMail',

  components: {
    PartnerCallSmsEmailMailOptions,
  },

  setup: () => {
    const route = useRoute();

    onMounted(async () => {
      const hash = route.hash;

      await nextTick();
      util.moveScrollComponent(hash);
    });
  },
};
</script>
